import { initialMarketState, MarketState } from '@store/state/market.state';
import { MarketActions, EnumMarketActions } from '@store/actions/market.action';

export function marketReducer(
    state = initialMarketState,
    action: MarketActions
): MarketState {
    switch (action.type) {
        case EnumMarketActions.GetMarket: {
            return {
                ...state,
                loading: { ...state.loading, list: true }
            };
        }
        case EnumMarketActions.SetMarket:
        case EnumMarketActions.GetMarketFailed: {
            return {
                ...state,
                list: action.type === EnumMarketActions.SetMarket ? action.markets : state.list,
                loading: { ...state.loading, list: false }
            };
        }
        case EnumMarketActions.GetMarketHome: {
            return {
                ...state,
                loading: { ...state.loading, home: true }
            };
        }
        case EnumMarketActions.SetMarketHome:
        case EnumMarketActions.GetMarketHomeFailed: {
            return {
                ...state,
                home: action.type === EnumMarketActions.SetMarketHome ? action.markets : state.home,
                loading: { ...state.loading, home: false }
            };
        }
        case EnumMarketActions.SetMarketDetails: {
            return {
                ...state,
                details: action.marketDetails
            };
        }
        case EnumMarketActions.SetMarketFilter: {
            return {
                ...state,
                filter: action.marketFilters
            };
        }
        default:
            return state;
    }
}
